module.exports = __webpack_public_path__ + "img/processing.b0a44134.svg";